import React, { useState, useEffect } from 'react';
import './select.scss';
import { PropTypes } from 'prop-types';

export const Select = ({
  onChangeSelection,
  items = [],
  placeholder,
  valueKey,
  selectedKey,
  selected,
  autoselect,
  onReset
}) => {
  const [open, setOpen] = useState(false);
  const [label, changeLabel] = useState(placeholder);

  const itemsAndplaceholder =
    onReset && items
      ? [{ [selectedKey || valueKey]: -1, name: placeholder }, ...items]
      : items;
  const toggle = () => {
    setOpen(!open);
  };

  const onSelect = (id, item) => {
    if (item[selectedKey || valueKey] === -1) {
      changeLabel(placeholder);
      onReset();
    } else {
      onChangeSelection(id, item);
    }
  };

  useEffect(() => {
    if (items) {
      let selectItem = { [selectedKey || valueKey]: -1, name: placeholder };
      selectItem = items.find(
        pro => pro[selectedKey || valueKey] === selected
      ) || { [selectedKey || valueKey]: -1, name: placeholder };
      changeLabel(selectItem.name);
    }
  }, [selected, items]);

  return (
    <div
      role='presentation'
      className={open ? 'select select__open' : 'select'}
      onClick={toggle}
    >
      <div className='selectLabel'>
        <span className='selectLabelTxt'>{label}</span>
      </div>
      <ul className='selectItems'>
        {itemsAndplaceholder &&
          itemsAndplaceholder.map(item => (
            <li
              key={item.ineId}
              className='selectItem'
              role='presentation'
              onClick={() => onSelect(item[valueKey], item)}
            >
              {item.name}
            </li>
          ))}
      </ul>
    </div>
  );
};
Select.propTypes = {
  onChangeSelection: PropTypes.func.isRequired,
  // eslint-disable-next-line
  items: PropTypes.array,
  placeholder: PropTypes.string,
  valueKey: PropTypes.string
};

Select.defaultProps = {
  placeholder: 'Seleccione un elemento',
  valueKey: 'id',
  selected: 'all',
  items: []
};

export default Select;
